import { createTextVNode as _createTextVNode2, createVNode as _createVNode2 } from "vue";
import "core-js/modules/es.error.cause.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "exit-team"
};
const _hoisted_2 = {
  class: "exit-team__tip"
};
const _hoisted_3 = {
  key: 0
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode( /*#__PURE__*/_toDisplayString('您是 ') + " ");

const _hoisted_5 = {
  class: "exit-team__tip_bold"
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString(' 的拥有者。\n可转让空间，或直接解散空间。'));

const _hoisted_7 = {
  key: 1
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode( /*#__PURE__*/_toDisplayString('您是 ') + " ");

const _hoisted_9 = {
  class: "exit-team__tip_bold"
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString(' 的管理员。\n退出后，您将无法访问空间里的内容。'));

const _hoisted_11 = {
  key: 2
};

const _hoisted_12 = /*#__PURE__*/_createTextVNode( /*#__PURE__*/_toDisplayString('确认退出 ') + " ");

const _hoisted_13 = {
  class: "exit-team__tip_bold"
};

const _hoisted_14 = /*#__PURE__*/_createTextVNode(" " + /*#__PURE__*/_toDisplayString(' ？ \n退出后，您将无法访问空间里的内容。'));

const _hoisted_15 = {
  class: "exit-team__footer__btn__left"
};

const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 取消 ");

import { computed } from 'vue';
import { NSpace, NButton, useMessage } from 'naive-ui';
import { useAppDialog } from '../appDialog';
import Icon from '@teams/common/components/icon';
import { checkNewGroupOwner } from '@teams/common/api/group';
export default /*#__PURE__*/_defineComponent({
  __name: 'exitTeamDialog',
  props: {
    name: null,
    type: null,
    spaceType: null,
    gid: null
  },
  emits: ["exitGroup", "deleteGroup", "changeOwner", "close"],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const appDialog = useAppDialog();
    const message = useMessage();

    const getCheckOwnerTip = code => {
      switch (code) {
        case 40021002:
          return '暂不支持将【个人空间】转让给【企业账号】';

        case 40021003:
          return '暂不支持将【企业空间】转让给【个人账号】';

        case 40021004:
          return '禁止将【当前企业的空间】转让给【其他企业的账号】';

        case 40021005:
          return '禁止将空间转让给【非空间成员】';

        default:
          return null;
      }
    };

    const onChangeOwnerSelect = async items => {
      const tip = await checkNewGroupOwner({
        group_id: props.gid,
        user_id: items[0].userid
      }).then(() => {
        return null;
      }).catch(res => {
        return getCheckOwnerTip(res.response.data.code);
      });

      if (tip) {
        message.error(tip);
        throw new Error(tip);
      }

      const transferContent = () => {
        return _createVNode2("div", null, [_createTextVNode2("\u5C06\u3010"), _createVNode2("b", null, [props.name]), _createTextVNode2("\u3011\u8F6C\u8BA9\u7ED9\u3010"), _createVNode2("b", null, [items[0].name]), _createTextVNode2("\u3011\u3002")]);
      };

      appDialog.show({
        name: 'inputConfirm',
        title: '转让协作空间',
        componentProps: {
          confirmText: '确认转让',
          okText: '确认转让',
          content: transferContent
        },
        componentEvents: {
          confirm: () => {
            emits('changeOwner', items[0].userid);
            appDialog.close();
          },
          close: () => {
            appDialog.close();
          }
        },
        modalProps: {
          style: {
            width: '440px'
          }
        }
      });
    };

    const okBtn = computed(() => {
      if (props.type === 'owner') {
        const dissolveContent = () => {
          return _createVNode2("div", {
            "class": 'dissolve-space-content'
          }, [_createVNode2(NSpace, {
            "class": 'dissolve-space-content_warn',
            "size": 6,
            "wrap": false
          }, {
            default: () => [_createVNode2("div", {
              "style": {
                'margin-top': '3px'
              }
            }, [_createVNode2(Icon, {
              "name": 'warn',
              "size": 16
            }, null)]), _createVNode2("div", null, [_createTextVNode2("\u8BE5\u64CD\u4F5C\u65E0\u6CD5\u64A4\u9500\uFF01\u5C06\u3010"), props.name, _createTextVNode2("\u3011\u89E3\u6563\u540E\uFF1A")])]
          }), _createVNode2("div", {
            "class": 'dissolve-space-content_normal'
          }, [_createVNode2("ul", null, [_createVNode2("li", null, [_createTextVNode2("\u5C06\u6E05\u9664\u5E94\u7528\u5185\u5BB9\u548C\u7A7A\u95F4\u6210\u5458")]), _createVNode2("li", null, [_createTextVNode2("\u5C06\u5220\u9664\u6587\u6863\u5E93\u5185\u5BB9")]), _createVNode2("li", null, [_createTextVNode2("\u6210\u5458\u5C06\u65E0\u6CD5\u8BBF\u95EE\u8BE5\u7A7A\u95F4")])])])]);
        };

        const delTeam = {
          text: '解散空间',
          btnType: 'error',
          onOk: () => {
            if (props.spaceType === 'personal' || props.spaceType === 'personal_not_dissolve') {
              message.warning('暂不支持解散个人空间');
              return;
            }

            appDialog.show({
              name: 'inputConfirm',
              title: '解散协作空间',
              componentProps: {
                confirmText: '确认解散',
                okText: '确认解散',
                content: dissolveContent
              },
              componentEvents: {
                confirm: () => {
                  emits('deleteGroup');
                  appDialog.close();
                }
              },
              modalProps: {
                style: {
                  width: '440px'
                }
              }
            });
          }
        };
        return delTeam;
      } else {
        return {
          text: '确认退出',
          btnType: 'error',
          onOk: () => {
            emits('exitGroup');
            emits('close');
          }
        };
      }
    });
    const leftBtn = computed(() => {
      if (props.type === 'owner') {
        const transferTeamBtn = {
          text: '转让空间',
          onOk: () => {
            if (props.spaceType === 'personal' || props.spaceType === 'personal_not_dissolve') {
              message.warning('暂不支持转让个人空间');
              return;
            }

            appDialog.show({
              name: 'MemberSelector',
              componentProps: {
                single: true,
                sources: [{
                  type: 'teamMember',
                  gid: props.gid,
                  role: ['member', 'admin']
                }],
                onConfirm: async items => {
                  await onChangeOwnerSelect(items);
                }
              }
            });
          }
        };
        return transferTeamBtn;
      } else {
        // 普通成员
        return null;
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [props.type === 'owner' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_hoisted_4, _createElementVNode("span", _hoisted_5, "【" + _toDisplayString(props.name) + "】", 1), _hoisted_6])) : props.type === 'manager' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", _hoisted_9, "【" + _toDisplayString(props.name) + "】", 1), _hoisted_10])) : props.type === 'member' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_hoisted_12, _createElementVNode("span", _hoisted_13, "【" + _toDisplayString(props.name) + "】", 1), _hoisted_14])) : _createCommentVNode("", true)]), _createVNode(_unref(NSpace), {
        justify: "space-between",
        class: "exit-team__footer"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [!!_unref(leftBtn) ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = //@ts-ignore
          (...args) => _unref(leftBtn)?.onOk && _unref(leftBtn)?.onOk(...args))
        }, _toDisplayString(_unref(leftBtn).text), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createVNode(_unref(NButton), {
          onClick: _cache[1] || (_cache[1] = $event => emits('close')),
          class: "exit-team__footer__btn"
        }, {
          default: _withCtx(() => [_hoisted_16]),
          _: 1
        }), _createVNode(_unref(NButton), {
          type: _unref(okBtn).btnType,
          onClick: _unref(okBtn).onOk,
          class: "exit-team__footer__btn"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(okBtn).text), 1)]),
          _: 1
        }, 8, ["type", "onClick"])])]),
        _: 1
      })]);
    };
  }

});